module.exports = __webpack_public_path__ + "static/media/cdr.2bc50373.svg";